export { default } from "./safe-area"
export type { SafeAreaPosition } from "./safe-area"
